import { Dialog } from "@ark-ui/react";
import Button from "../../Button/Button";
import Icon from "../../Icon/Icon";

interface DrawerCloseTriggerProps {
  fullWidth?: boolean;
  classes: { closeTrigger: string };
}

const DrawerCloseTrigger = ({
  fullWidth,
  classes,
}: DrawerCloseTriggerProps) => {
  const asButton = !fullWidth;
  return (
    <Dialog.CloseTrigger asChild={asButton} className={classes.closeTrigger}>
      {asButton ? (
        <Button iconOnly hierarchy="secondary-subtler" testId="drawer-close">
          <Icon name="x" />
        </Button>
      ) : null}
    </Dialog.CloseTrigger>
  );
};

export default DrawerCloseTrigger;
